import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";

const EmptyStateCard = ({ icon, title, subtitle }) => {
  return (
    <Box
      sx={{
        mt: 2,
        borderRadius: "18px",
        border: "1px solid rgba(255,255,255,0.12)",
        background:
          "linear-gradient(135deg, rgba(255,255,255,0.10), rgba(255,255,255,0.04))",
        backdropFilter: "blur(10px)",
        boxShadow: "0 18px 48px rgba(0,0,0,0.35)",
        p: { xs: 2.2, sm: 3 },
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* subtle glow */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background:
            "radial-gradient(600px 220px at 50% 0%, rgba(99,102,241,0.22), transparent 60%)",
        }}
      />

      <Box
        sx={{
          width: 62,
          height: 62,
          mx: "auto",
          borderRadius: "18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid rgba(255,255,255,0.14)",
          backgroundColor: "rgba(255,255,255,0.08)",
          boxShadow: "0 12px 28px rgba(0,0,0,0.28)",
          mb: 1.4,
          position: "relative",
          zIndex: 1,
        }}
      >
        {icon}
      </Box>

      <Typography
        sx={{
          color: "rgba(255,255,255,0.92)",
          fontWeight: 950,
          letterSpacing: "0.2px",
          fontSize: { xs: "1.05rem", sm: "1.1rem" },
          position: "relative",
          zIndex: 1,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          mt: 0.6,
          color: "rgba(255,255,255,0.72)",
          fontSize: "0.92rem",
          lineHeight: 1.45,
          maxWidth: 520,
          mx: "auto",
          position: "relative",
          zIndex: 1,
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

EmptyStateCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default EmptyStateCard;
